import Vue from 'vue'
import App from './App.vue'
import DataV from '@jiaminghi/data-view'
import ECharts from 'vue-echarts'
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { LineChart, BarChart, PieChart, ScatterChart, RadarChart, MapChart, EffectScatterChart } from 'echarts/charts'
import {
  TitleComponent, TooltipComponent, LegendComponent, GridComponent,
  VisualMapComponent, GeoComponent, VisualMapContinuousComponent
} from 'echarts/components'

use([
  CanvasRenderer, LineChart, BarChart, PieChart, ScatterChart, RadarChart,
  MapChart, EffectScatterChart, TitleComponent, TooltipComponent,
  LegendComponent, GridComponent, VisualMapComponent, GeoComponent,
  VisualMapContinuousComponent
])

Vue.use(DataV)
Vue.component('v-chart', ECharts)

Vue.config.productionTip = false

new Vue({
  render: h => h(App)
}).$mount('#app')
